import GuidanceScaleSelection from './GuidanceScaleSelection'

export default GuidanceScaleSelection
